import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'underscore';
import { Text } from '@bingads-webui-react/fabric-control';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { PropertyRow } from '@bingads-webui-campaign-react/ui-generator';
import { SelectedItem } from '@bingads-webui-campaign-react/pill-item-components';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';

const getProductsStyle = () => ({
  productFilterItem: {
    marginBottom: 5,
  },
});

export const Products = ({ productFilters, useSelectedItem }) => {
  const i18n = useContext(I18nContext);
  const classes = useDefaultStyles(getProductsStyle);

  let productsText = '';

  if (isEmpty(productFilters)) {
    productsText = i18n.getString(_TL_('All products'));
  } else if (!useSelectedItem) {
    productsText = productFilters.join(' & ');
  }

  return (
    <PropertyRow propertyLabel={{ label: _TL_('Products') }}>
      {useSelectedItem && !isEmpty(productFilters) ?
        productFilters.map((filter, index) => (
          <div key={filter} className={classes.productFilterItem}>
            <SelectedItem
              key={filter}
              itemText={filter}
              itemIndex={index}
              maxContentWidth
            />
          </div>)) :
        (<Text>{productsText}</Text>)}
    </PropertyRow>
  );
};

Products.propTypes = {
  productFilters: PropTypes.arrayOf(PropTypes.string),
  useSelectedItem: PropTypes.bool,
};

Products.defaultProps = {
  productFilters: [],
  useSelectedItem: false,
};
